import {
  Box, Button, ImageList, Modal, Stack, ImageListItem,
} from '@mui/material';
import { useMemo, useState } from 'react';
import InputImage from '../../Form/InputImage';
import styles from './ImageModalPopUp.module.css';
import { ImageTypeValue } from '../../../utils/image';

const style = {
  position: 'absolute',
  overflow: 'auto',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  maxWidth: '80%',
  maxHeight: '80%',
  height: '80%',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 2,
};

interface ImageModalPopUpProps {
  images: { id:number, url: string }[]
  handleSave: (selectedImageId: number) => void
  modalShow: boolean
  onClose: (event: React.MouseEvent) => void;
}

const imageClassName = (selectedImageId:number | null, imageId: number): string => {
  if (selectedImageId === imageId) {
    return [styles.imageListItemImg, styles.imageListItemImgSelected].join(' ');
  }

  return styles.imageListItemImg;
};

function ImageModalPopUp(props: ImageModalPopUpProps) {
  const {
    images, handleSave, modalShow, onClose,
  } = props;

  const [selectedImageId, setSelectedImageId] = useState<number | null>(null);

  const imageItems = useMemo(() => images.map((img) => ({
    url: `${process.env.REACT_APP_API_URL}/${img.url}`,
    id: img.id,
  })), [images]);

  return (
    <Modal
      open={modalShow}
      onClose={onClose}
    >
      <Box sx={style}>
        <Stack
          direction="row"
          justifyContent="start"
          alignItems="center"
          sx={{
            height: '10%',
          }}
        >
          背景画像を選択してください
        </Stack>

        <Box sx={{ height: '80%' }}>
          <ImageList cols={5} gap={8} rowHeight={164} className={styles.imageList}>
            {imageItems.map((item) => (
              <ImageListItem key={item.id}>
                <img
                  role="presentation"
                  className={imageClassName(selectedImageId, item.id)}
                  src={`${item.url}`}
                  srcSet={`${item.url}`}
                  alt=""
                  loading="lazy"
                  onClick={() => setSelectedImageId(item.id)}
                />
              </ImageListItem>
            ))}
          </ImageList>
        </Box>

        <Stack
          direction="row"
          justifyContent="end"
          alignItems="center"
          spacing={2}
          sx={{
            height: '10%',
          }}
        >
          <Button variant="outlined" color="primary" onClick={onClose}>
            キャンセル
          </Button>

          <Button
            variant="contained"
            component="label"
            sx={{
              position: 'relative',
            }}
          >
            ローカルから選択
            <InputImage
              type={ImageTypeValue.SYSTEM_IMAGE}
              id="id"
              isDisabled={false}
              fileHandler={(url) => {
                console.log(url);
              }}
            />
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (selectedImageId == null) {
                return;
              }
              handleSave(selectedImageId);
            }}
          >
            適用
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}

export default ImageModalPopUp;
